export default function generateAccountingCode (item, accountingCodes) {
  console.log('generateAccountingCode', item)
  const mappingItem = accountingMapping.find(mappingItem => compareCodes(item, mappingItem))
  console.log('mappingItem', mappingItem)

  // Get the 3 characters from the code
  const foundAccountingCode = mappingItem?.accountingCode

  // Make it an account code with 5 characters
  let newAccountingCode = foundAccountingCode * 100
  while (accountingCodes.includes(newAccountingCode)) {
    newAccountingCode++
  }

  return newAccountingCode
}

function compareCodes (item, mappingItem) {
  console.log('compareCodes', item, mappingItem)
  const v1 = item.Code?.replace(/\./g, '').trim().toLowerCase()
  const v2 = mappingItem.code?.replace(/\./g, '').trim().toLowerCase()
  return v1 === v2
}

const accountingMapping = [
  {
    code: 'A1',
    name: 'STORY & SCRIPT',
    accountingCode: 661,
    groupAboveBelowLine: 'above'
  },
  {
    code: 'A2',
    name: 'DEVELOPMENT',
    accountingCode: 662,
    groupAboveBelowLine: 'above'
  },
  {
    code: 'B.1',
    name: 'PRODUCERS',
    accountingCode: 663,
    groupAboveBelowLine: 'above'
  },
  {
    code: 'B.2',
    name: 'DIRECTORS',
    accountingCode: 664,
    groupAboveBelowLine: 'above'
  },
  {
    code: 'E(a)',
    name: 'PRINCIPAL CAST',
    accountingCode: 665,
    groupAboveBelowLine: 'above'
  },
  {
    code: 'E(a)1',
    name: 'OFFSHORE CAST',
    accountingCode: 666,
    groupAboveBelowLine: 'above'
  },
  {
    code: 'E(a)2',
    name: 'AUSTRALIAN CAST',
    accountingCode: 667,
    groupAboveBelowLine: 'above'
  },
  {
    code: 'C.',
    name: 'PRODUCTION UNIT FEES & SALARIES.',
    accountingCode: 730,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.1',
    name: 'PRODUCTION MANAGEMENT',
    accountingCode: 730,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.2',
    name: 'PRODUCTION ACCOUNTANCY',
    accountingCode: 731,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.3',
    name: 'ASSISTANT DIRECTORS & SCRIPT SUPERVISION (DRAMA)',
    accountingCode: 732,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.4',
    name: 'CAMERA  CREW',
    accountingCode: 733,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.5',
    name: 'SOUND  CREW',
    accountingCode: 734,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.6',
    name: 'LIGHTING CREW',
    accountingCode: 735,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.7',
    name: 'GRIPS   CREW',
    accountingCode: 736,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.8',
    name: 'COSTUME CREW (DRAMA)',
    accountingCode: 737,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.9',
    name: 'MAKE-UP CREW (DRAMA)',
    accountingCode: 738,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.10',
    name: 'HAIRDRESSING CREW (DRAMA)',
    accountingCode: 739,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.11',
    name: 'ART DEPARTMENT CREW (DRAMA)',
    accountingCode: 740,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.12',
    name: 'ACTION VEHICLES CREW (DRAMA)',
    accountingCode: 741,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.13',
    name: 'LIVESTOCK CREW (DRAMA)',
    accountingCode: 742,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.14',
    name: 'CONSTRUCTION  CREW (DRAMA)',
    accountingCode: 743,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.15',
    name: 'SPECIAL EFFECTS & ARMOURY CREW (DRAMA)',
    accountingCode: 744,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.16',
    name: 'VISUAL EFFECTS & ANIMATION',
    accountingCode: 745,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.17',
    name: 'OCCUPATIONAL HEALTH & SAFETY CREW ',
    accountingCode: 746,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.18',
    name: 'TECHNICAL ADVISERS',
    accountingCode: 747,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.19',
    name: 'SECOND UNIT CREW',
    accountingCode: 748,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.20',
    name: 'OVERSEAS CREW',
    accountingCode: 749,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'C.24',
    name: 'OVERTIME & LOADINGS',
    accountingCode: 750,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'D',
    name: 'FRINGES & WORKERS COMPENSATION',
    accountingCode: 760,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'E(b)',
    name: 'CAST & CASTING',
    accountingCode: 770,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'F.1',
    name: 'COSTUMES (DRAMA) ',
    accountingCode: 771,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'F.2',
    name: 'MAKE-UP & HAIRDRESSING (DRAMA)',
    accountingCode: 772,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'G.1',
    name: 'LOCATIONS',
    accountingCode: 778,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'G.2',
    name: 'STUDIO/STAGE RENTALS',
    accountingCode: 779,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'H.',
    name: 'SETS & PROPERTIES',
    accountingCode: 780,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'H.1',
    name: 'CONSTRUCTION  (DRAMA)',
    accountingCode: 780,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'H.2',
    name: 'PROPS & SET DRESSING (DRAMA)',
    accountingCode: 781,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'H.3',
    name: 'ACTION PROPS & VEHICLES',
    accountingCode: 782,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'H.4',
    name: 'LIVESTOCK  ',
    accountingCode: 783,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'H.5',
    name: 'SPECIAL EFFECTS & ARMOURY ',
    accountingCode: 784,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'H.6',
    name: 'VISUAL EFFECTS - Shoot Only ',
    accountingCode: 785,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'H.7',
    name: 'ANIMATION & PUPPETRY- Shoot Only ',
    accountingCode: 786,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'I.',
    name: 'STOCK, PROCESSING AND TRANSFERS',
    accountingCode: 787,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'I.a',
    name: 'STOCK, PROCESSING AND TRANSFERS - FILM & LAB - Shooting',
    accountingCode: 787,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'I.b',
    name: 'STOCK, PROCESSING AND TRANSFERS - TAPE & HD',
    accountingCode: 788,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'J.',
    name: 'INSERTS, STILLS AND ARCHIVAL FOOTAGE',
    accountingCode: 788,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'K.',
    name: 'EQUIPMENT & STORES',
    accountingCode: 790,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'K.1',
    name: 'CAMERA EQUIPMENT & STORES ',
    accountingCode: 790,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'K.2',
    name: 'SOUND EQUIPMENT & STORES',
    accountingCode: 791,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'K.3',
    name: 'LIGHTING EQUIPMENT & STORES ',
    accountingCode: 792,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'K.4',
    name: 'GRIPS EQUIPMENT & STORES',
    accountingCode: 793,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'K.5',
    name: 'UNIT FACILITIES & STORES',
    accountingCode: 794,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'K.6',
    name: 'SAFETY EQUIPMENT & STORES',
    accountingCode: 795,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'L.',
    name: 'RENTALS & STORAGE',
    accountingCode: 796,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'M.',
    name: 'TRAVEL & TRANSPORT ',
    accountingCode: 797,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'N.',
    name: 'ACCOMMODATION, LIVING, CATERING ',
    accountingCode: 798,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'O.',
    name: 'INSURANCES ',
    accountingCode: 799,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'P.',
    name: 'OFFICE EXPENSES',
    accountingCode: 800,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'Q.',
    name: 'OFFSHORE SHOOT ',
    accountingCode: 801,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'R.',
    name: 'POST-PRODUCTION CREW',
    accountingCode: 803,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'S',
    name: 'POST-PRODN. RENTALS & OFFICE EXPENSES',
    accountingCode: 804,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'T',
    name: 'POST-PRODN. TRAVEL & ACCOMMODATION',
    accountingCode: 805,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'U.1',
    name: 'PICTURE POST-PRODUCTION (FINISHING ON TAPE)',
    accountingCode: 806,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'U.2',
    name: 'DIGITAL VISUAL EFFECTS',
    accountingCode: 807,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'V',
    name: 'SOUND - POST PRODUCTION',
    accountingCode: 808,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'W',
    name: 'MUSIC',
    accountingCode: 809,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'X.1',
    name: 'PUBLICITY & STILLS - PRODUCTION & POST PRODN.',
    accountingCode: 810,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'X.2',
    name: 'DELIVERY REQUIREMENTS',
    accountingCode: 811,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'Y',
    name: 'LEGAL & BUSINESS',
    accountingCode: 812,
    groupAboveBelowLine: 'below'
  },
  {
    code: 'Z',
    name: 'OVERHEADS',
    accountingCode: 813,
    groupAboveBelowLine: 'below'
  }
]
